import React from 'react'
import IntroHome from './IntroHome'
import OurProducts from './OurProducts'
import ContactHome from './ContactHome'
import CaseStudy from './CaseStudy'
import Partner from './Partner'
// import SectionA from './SectionA'

export default function AllSections() {
  return (
    <div>
      
      <IntroHome/>
          {/* <SectionA/> */}
          <OurProducts/>
          <ContactHome/>
          <CaseStudy/>
          <Partner/>

    </div>
  )
}
